<template><ArchiveTerm kind="view" :plural="plural" /></template>
<script>
import ArchiveTerm from './ArchiveTerm.vue';
export default {
  name: 'AiViewTerm',
  components: { ArchiveTerm },
  props: { plural: { type: Boolean, default: false } },
};
</script>
